import(/* webpackMode: "eager" */ "/app/src/app/(app)/(tabs)/layout.tsx");
